import { IButtonStyles } from '@fluentui/react/';
import { ITextStyles } from '@fluentui/react/';
import { mergeStyles } from '@fluentui/react/';

export const textContainer = mergeStyles({
    marginTop: 15,
    paddingTop: 10,
    paddingBottom: 10,
})

export const cos = mergeStyles({
    marginTop: 10
})

export const textS: ITextStyles = {
    root:{
        marginBottom: 5
    }
}

export const closeBtnS: IButtonStyles= {
    root:{
        marginTop: 15
    }
}